// AI-CONTEXT: See docs/features/compare-two-periods.md
//
// Fixed colours for the two periods in every compare view (grouped bars, KPI
// delta, small-multiple titles) so "which is which" reads instantly. Brand
// teal for the primary period, brand coral for the compare period.

const periodCompareColors = Object.freeze({
    A: '#47acc3', // primary period (brand teal)
    B: '#f38284', // compare period (brand coral)
})

export default periodCompareColors
